import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {MatSnackBar} from '@angular/material';
import {KongService} from '../kong.service';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {AuthedApiService} from "../authed-api.service";
import {ImportFileDialogComponent} from "../createfromopenapi/import-file-dialog/import-file-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-cobol-to-api',
  templateUrl: './cobol-to-api.component.html',
  styleUrls: ['./cobol-to-api.component.scss']
})
export class CobolToApiComponent implements OnInit {

  code: string;
  showNextPanel = false;
  deploymentPlan: any;
  apiExecutorPlans = [];
  entityPlans: any;
  dataMigrationPlans: any;
  defaultDatabase = 'default';
  apiKeys: any;
  apiKeyData: any;
  apiKey: any;
  loading = false;

  retries = 0;

  constructor(public dialog: MatDialog,
              public platform: LeftpanelComponent,
              private apiService: AuthedApiService) { }

  ngOnInit() {
  }

  openFileUploadDialog() {
    const dialogRef = this.dialog.open(ImportFileDialogComponent, {
      height: '50%',
      width: '50%'
    });
    dialogRef.afterClosed().subscribe(async file => {
      if (file) {
        const reader = new FileReader();
        // this.modeler.importXML(file, value => this.handleError(value));
        reader.addEventListener('load', (event: any) => {
          this.code = event.target.result.toString();
        });
        reader.readAsText(file);
      }
    });
  }


  getDeploymentPlanForCOBOL() {
    this.loading = true;
    if (this.code !== undefined) {
      // this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        // this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(data['primary_email']).subscribe(keys => {
        //   this.apiKeyData = keys;
        //   this.apiKeys = this.apiKeyData.data;
        //   this.apiKey = this.apiKeys[0].key;
        this.apiKey = localStorage.getItem('apikey');
          this.apiService.getDeploymentPlanForCOBOL(this.code, this.apiKey, 'openapi').subscribe(response => {
            this.deploymentPlan = response;
            // this.entityPlans = response['entityModels'];
            // this.apiExecutorPlans[0] = response['executorModel'];
            // this.dataMigrationPlans = null;
            this.loading = false;
            this.showNextPanel = true;
          }, error => {
            this.retries += 1;
            if (this.retries <= 5) {
              setTimeout(() => {
                this.getDeploymentPlanForCOBOL();
              }, 5000);
            }
            if (this.retries > 5) {
              this.loading = false;
              this.platform.handleErrorGracefully(error, 'Error in transforming COBOL snippet. Please try again after sometime.');
              // this.platform.openSnackBar('Error in transforming COBOL snippet. Please try again after sometime.', 'Error', {
              //   duration: 10000,
              //   verticalPosition: 'top',
              //   horizontalPosition: 'center'
              // });
            }
          });
        // });
      // });
    } else {
      this.loading = false;
      alert('Please enter a code snippet to transform');
    }
    // this.confPost.getDeploymentPlanForCOBOL(localStorage.getItem('partner'), localStorage.getItem('account'), this.code).subscribe()
  }

  refreshComponent() {
    this.showNextPanel = false;
    this.loading = false;
  }

  createMarginRight() {
    document.getElementById('view:cobol_to_api').style.marginRight = '400px';
  }

  removeMarginRight() {
    document.getElementById('view:cobol_to_api').style.marginRight = '0px';
  }
}

